module.exports = "//static.hsappstatic.net/ContentComponents/static-2.62696/img/landing-page-zero.png"